var _rect, _path, _rect2, _path2, _rect3, _path3, _rect4, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgControls(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 181,
    viewBox: "0 0 278 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 98.3143,
    y: 0.87,
    width: 81.78,
    height: 81.78,
    rx: 13.05,
    stroke: "white",
    strokeWidth: 1.74
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.165 48.5164C150.812 48.8687 150.334 49.0667 149.836 49.0667C149.338 49.0667 148.86 48.8687 148.507 48.5164L139.205 39.2144L129.903 48.5164C129.549 48.8588 129.074 49.0482 128.582 49.0439C128.089 49.0396 127.617 48.842 127.269 48.4936C126.921 48.1451 126.723 47.6738 126.719 47.1811C126.714 46.6884 126.904 46.2137 127.246 45.8593L137.877 35.2286C138.229 34.8763 138.707 34.6784 139.205 34.6784C139.704 34.6784 140.182 34.8763 140.534 35.2286L151.165 45.8593C151.517 46.2117 151.715 46.6896 151.715 47.1879C151.715 47.6861 151.517 48.164 151.165 48.5164Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 98.3143,
    y: 97.7955,
    width: 81.78,
    height: 81.78,
    rx: 13.05,
    stroke: "white",
    strokeWidth: 1.74
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.245 131.929C127.597 131.577 128.075 131.379 128.573 131.379C129.071 131.379 129.549 131.577 129.902 131.929L139.204 141.231L148.506 131.929C148.86 131.586 149.335 131.397 149.828 131.401C150.32 131.406 150.792 131.603 151.14 131.952C151.489 132.3 151.686 132.771 151.69 133.264C151.695 133.757 151.505 134.232 151.163 134.586L140.532 145.217C140.18 145.569 139.702 145.767 139.204 145.767C138.705 145.767 138.228 145.569 137.875 145.217L127.245 134.586C126.892 134.234 126.694 133.756 126.694 133.257C126.694 132.759 126.892 132.281 127.245 131.929Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 195.24,
    y: 97.7955,
    width: 81.78,
    height: 81.78,
    rx: 13.05,
    stroke: "white",
    strokeWidth: 1.74
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M229.371 150.645C229.019 150.293 228.821 149.815 228.821 149.317C228.821 148.818 229.019 148.34 229.371 147.988L238.674 138.686L229.371 129.384C229.029 129.03 228.84 128.555 228.844 128.062C228.848 127.569 229.046 127.098 229.394 126.75C229.743 126.401 230.214 126.204 230.707 126.199C231.2 126.195 231.674 126.384 232.029 126.727L242.659 137.357C243.012 137.71 243.21 138.188 243.21 138.686C243.21 139.184 243.012 139.662 242.659 140.015L232.029 150.645C231.676 150.998 231.198 151.195 230.7 151.195C230.202 151.195 229.724 150.998 229.371 150.645Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.38953,
    y: 97.7955,
    width: 81.78,
    height: 81.78,
    rx: 13.05,
    stroke: "white",
    strokeWidth: 1.74
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0348 126.726C49.3871 127.078 49.585 127.556 49.585 128.054C49.585 128.553 49.3871 129.031 49.0348 129.383L39.7327 138.685L49.0348 147.987C49.3771 148.341 49.5665 148.816 49.5622 149.309C49.5579 149.802 49.3603 150.273 49.0119 150.621C48.6634 150.97 48.1921 151.167 47.6994 151.172C47.2067 151.176 46.732 150.987 46.3776 150.644L35.7469 140.014C35.3946 139.661 35.1967 139.183 35.1967 138.685C35.1967 138.187 35.3946 137.709 35.7469 137.356L46.3776 126.726C46.73 126.374 47.2079 126.176 47.7062 126.176C48.2045 126.176 48.6824 126.374 49.0348 126.726Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControls);
export default __webpack_public_path__ + "static/media/Controls.486ea0f0b6d186dcb6516210d3294e2c.svg";
export { ForwardRef as ReactComponent };